import { CSSProperties } from 'react';
import { StringKeyedDictionary } from '../../typescriptHelpers';
import { antGrey } from './globalStyles';

const styles: StringKeyedDictionary<React.CSSProperties> = {
    appSettingsSectionTitleStyle: { fontSize: 15, fontWeight: 700, color: antGrey.grey9 } as CSSProperties,
    descriptionsWidthStyle: {} as CSSProperties,
    descriptionsLabelStyle: {
        width: '30%',
        maxWidth: 300,
    } as CSSProperties,
};

export default styles;
